export const FLAGS = {
  PDP_SIZE_OPTIONS: 'pdp-size-options',
  CART_RECOMMENDATIONS_POSITION: 'cart-recommendations-position'
} as const

// Fill in locally to test variant experiences in development. Must be empty in commits.
export const DEV_FLAG_OVERRIDES: Record<string, string> = {}
